export const settingsRoutes = {
  path: "/",
  to: "/",
  icon: "mdi-cogs",
  activeRoutes: ["record_system", "record_currencies", "record_meta_search_settings", "record_addition_services"],
  meta: {
    title: "settings",
    // permissions: "",
  },
  order: 4,
  allow_children: true,
  showInMenu: true,
  name: "settings",
  component: () => import("@/views/settings"),
  children: [
    {
      path: "/system-settings",
      to: "/system-settings",
      component: () => import("@/views/settings/system/index"),
      name: "system-settings",
      icon: "mdi-flag",
      allowed: true,
      meta: {
        title: "system_settings",
        // permissions: 7
      },
      activeRoutes: ["record_system"], // Specify the activeRoutes for the "cities" route

      children: [
        {
          path: "",
          component: () => import("@/views/settings/system/record/index"),
          name: "record_system",
          icon: "arrow.svg",
          to: "/countries",
          allowed: true,
          meta: {
            title: "record_system",
            // permissions: 7
          },
        }

      ],
    },
    {
      path: "/currencies",
      to: "/currencies",
      component: () => import("@/views/settings/currency/index"),
      name: "currencies",
      icon: "mdi-cash",
      allowed: true,
      meta: {
        title: "currencies",
        // permissions: 7
      },
      activeRoutes: ["record_currencies"], // Specify the activeRoutes for the "cities" route

      children: [
        {
          path: "",
          component: () => import("@/views/settings/currency/record/index"),
          name: "record_currencies",
          icon: "arrow.svg",
          to: "/currencies",
          allowed: true,
          meta: {
            title: "record_currencies",
            // permissions: 7
          },
        }

      ],
    },
    {
      path: "/meta-search-settings",
      to: "/meta-search-settings",
      component: () => import("@/views/settings/metaSearch/index"),
      name: "meta-search-settings",
      icon: "mdi-earth",
      allowed: true,
      meta: {
        title: "meta_search_settings",
        // permissions: 7
      },
      activeRoutes: ["record_meta_search_settings"],

      children: [
        {
          path: "",
          component: () => import("@/views/settings/metaSearch/record/index"),
          name: "record_meta_search_settings",
          icon: "arrow.svg",
          to: "/meta-search-settings",
          allowed: true,
          meta: {
            title: "record_meta_search_settings",
            // permissions: 7
          },
        },
      ],
    },
    {
      path: "/addition-services",
      to: "/addition-services",
      component: () => import("@/views/settings/additionServices/index"),
      name: "addition-services",
      icon: "mdi-shopping-outline",
      allowed: true,
      meta: {
        title: "addition_services",
        // permissions: 7
      },
      activeRoutes: ["record_addition_services"],

      children: [
        {
          path: "",
          component: () => import("@/views/settings/additionServices/record/index"),
          name: "record_addition_services",
          icon: "arrow.svg",
          to: "/addition-services",
          allowed: true,
          meta: {
            title: "record_addition_services",
            // permissions: 7
          },
        },
        {
          path: "/addition-services/create",
          name: "create_addition_service",
          component: () => import("@/views/settings/additionServices/form/index"),
        },
        {
          path: "/addition-services/:id/edit",
          name: "edit_addition_service",
          component: () => import("@/views/settings/additionServices/form/index"),
        },

      ],
    },

  ]
};
